"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var classnames_1 = __importDefault(require("classnames"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var input_dropzone_jsx_1 = __importDefault(require("~/components/forms/inputs/input_dropzone.jsx"));
var input_resizing_dropzone_store_1 = __importDefault(require("~/stores/forms/builder/input_resizing_dropzone_store"));
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var EncouragePhotoModal = /** @class */ (function (_super) {
    __extends(EncouragePhotoModal, _super);
    function EncouragePhotoModal(props) {
        var _this = _super.call(this, props) || this;
        _this.photoMessageId = 0;
        _this.postPhoto = function () {
            var _a = _this.props, photoEndpoint = _a.photoEndpoint, photoName = _a.photoName, shouldShareMessage = _a.shouldShareMessage;
            var data = new FormData();
            var value = _this.dropzoneStore.getValue();
            if (!value) {
                return Promise.resolve();
            }
            data.append(photoName, value);
            google_analytics_manager_1.default.postGAEvent('マイページ', 'click', '画像添付ポップアップ送信');
            return axios_1.default
                .post(photoEndpoint, data)
                .then(function (result) {
                if (!shouldShareMessage) {
                    window.location.reload();
                }
                else {
                    _this.photoMessageId = result.data.id;
                }
            })
                .catch(function (error) {
                if (error.response.data.messages) {
                    dialog_store_1.default.showDialogWithCloseButton('画像の保存に失敗しました', error.response.data.messages.join('<br/>'), undefined);
                }
                else {
                    throw JSON.stringify(error.response);
                }
            });
        };
        _this.dropzoneStore = new input_resizing_dropzone_store_1.default();
        _this.isOpen = props.isOpen;
        return _this;
    }
    Object.defineProperty(EncouragePhotoModal.prototype, "submitDisabled", {
        get: function () {
            return this.dropzoneStore.getValue() === undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EncouragePhotoModal.prototype, "formTitle", {
        get: function () {
            return this.photoMessageId ? '添付が完了しました！' : '画像を添付してみませんか？';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EncouragePhotoModal.prototype, "formDescription", {
        get: function () {
            return (this.photoMessageId
                ? react_1.default.createElement(react_1.default.Fragment, null,
                    "\u3053\u306E\u753B\u50CF\u3092\u305D\u306E\u4ED6\u306E\u696D\u8005\u306B\u3082\u8EE2\u9001\u3057\u307E\u3059\u304B\uFF1F",
                    react_1.default.createElement("br", null),
                    "\u203B\u73FE\u6642\u70B9\u3067\u8FD4\u4FE1\u306E\u3042\u308B\u5168\u3066\u306E\u696D\u8005\u3078\u8EE2\u9001\u3057\u307E\u3059")
                : react_1.default.createElement(react_1.default.Fragment, null,
                    "\u67FB\u5B9A\u5E0C\u671B\u5546\u54C1\u306E\u753B\u50CF\u3092\u6DFB\u4ED8\u3059\u308B\u3068",
                    react_1.default.createElement("br", null),
                    "\u3088\u308A\u8A73\u7D30\u306A\u67FB\u5B9A\u304C\u53EF\u80FD\u306B\u306A\u308A\u4FA1\u683CUP\u3082\u671F\u5F85\u3067\u304D\u307E\u3059\uFF01"));
        },
        enumerable: false,
        configurable: true
    });
    EncouragePhotoModal.prototype.render = function () {
        var _this = this;
        var imageSrc = this.dropzoneStore.getValue();
        var selectedFileName = this.dropzoneStore.getFileName();
        return (react_1.default.createElement(react_responsive_modal_1.default, { open: this.isOpen, onClose: function () { _this.isOpen = false; }, classNames: { modal: "usersEstimatesRequestsMessages-EncouragePhotoModal_Container" } },
            react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-EncouragePhotoModal_Title text-center mt5" }, this.formTitle),
            react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-EncouragePhotoModal_Description text-center mt5 mb5" }, this.formDescription),
            this.photoMessageId
                ? react_1.default.createElement("div", null,
                    react_1.default.createElement("form", { action: this.props.sharedMessagesEndpoint, method: "post" },
                        react_1.default.createElement("input", { type: "hidden", name: "message_id", value: this.photoMessageId }),
                        react_1.default.createElement("input", { type: "hidden", name: "authenticity_token", value: this.props.authenticityToken }),
                        react_1.default.createElement("button", { type: "submit", className: "usersEstimatesRequestsMessages-EncouragePhotoModal_SubmitButton", onClick: function () {
                                google_analytics_manager_1.default.postGAEvent('マイページ', 'click', '画像シェアポップアップ送信');
                            } }, "\u8EE2\u9001\u3059\u308B")))
                : react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-EncouragePhotoModal_PhotoInputWrapper" }, imageSrc
                        ? react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("img", { src: imageSrc, alt: selectedFileName || '選択済みの画像', className: "usersEstimatesRequestsMessages-EncouragePhotoModal_SelectedImage lazyload" }),
                            react_1.default.createElement("button", { className: "sw-Button sw-Button-negative usersEstimatesRequestsMessages-EncouragePhotoModal_DeleteImageButton", onClick: this.dropzoneStore.resetValue }, "\u53D6\u6D88"))
                        // FIXME: 型推論がうまく行ってくれなくてエラーになるのでいったん諦め(InputResizingDropzoneStoreをTSにすれば多分治る)
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        : react_1.default.createElement(input_dropzone_jsx_1.default, { store: this.dropzoneStore },
                            react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-EncouragePhotoModal_PhotoButton" },
                                react_1.default.createElement("i", { className: "fa fa-camera" }),
                                react_1.default.createElement("span", { className: "fs12 ml5" }, "\u753B\u50CF\u3092\u6DFB\u4ED8\u3059\u308B")))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("button", { onClick: this.postPhoto, className: (0, classnames_1.default)('usersEstimatesRequestsMessages-EncouragePhotoModal_SubmitButton', { 'usersEstimatesRequestsMessages-Form_SubmitButton-disabled': this.submitDisabled }), disabled: this.submitDisabled }, "\u9001\u4FE1")))));
    };
    var _a, _b;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof input_resizing_dropzone_store_1.default !== "undefined" && input_resizing_dropzone_store_1.default) === "function" ? _a : Object)
    ], EncouragePhotoModal.prototype, "dropzoneStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], EncouragePhotoModal.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], EncouragePhotoModal.prototype, "photoMessageId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], EncouragePhotoModal.prototype, "submitDisabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], EncouragePhotoModal.prototype, "formTitle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof react_1.default !== "undefined" && react_1.default.ReactNode) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], EncouragePhotoModal.prototype, "formDescription", null);
    EncouragePhotoModal = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], EncouragePhotoModal);
    return EncouragePhotoModal;
}(react_1.default.PureComponent));
exports.default = EncouragePhotoModal;
